<template>
  <div>
    <div class="section-titre bg-rouge">
      <div class="container" v-if="!alreadySubmit">
        <h2 v-if="campagne.url.includes('nouvelle-hornet')">
          Inscrivez-vous à l’évènement de lancement de la Hornet
        </h2>
        <h2 v-else>
          Contactez
          {{
            concession_name !== ""
              ? concession_name
              : "votre concessionnaire Honda"
          }}
        </h2>
        <h3 class="mb-0" v-if="campagne.url.includes('nouvelle-hornet')">
          La toute nouvelle Hornet sort son dard…Et se donne les moyens de
          piquer&nbsp;!
        </h3>
        <h3 class="mb-0" v-else>
          Pour réserver votre essai Honda gratuit en concession
        </h3>
      </div>
      <div class="container" v-else>
        <h2 class="pb-0" v-if="campagne.url.includes('nouvelle-hornet')">
          <strong>Merci pour votre participation.</strong>
        </h2>

        <h2 class="mb-0 pb-0 text-center" v-else>
          <strong>
            Merci pour votre demande d’essai,<br />nous revenons vers vous dès
            que possible pour fixer un rendez-vous.
          </strong>
        </h2>
      </div>
    </div>
    <div
      id="wrapper-form-reservation"
      class="wrapper-form-reservation container"
    >
      <div class="d-block message text-center" v-if="alreadySubmit">
        <span v-if="campagne.url.includes('nouvelle-hornet')">
          <strong>
            Votre inscription à l'évènement Hornet a bien été prise en
            compte,<br />
            Vous recevrez d'ici quelques jours des informations complémentaires
            sur le déroulé de l'évènement.<br /><br />
            L'équipe Honda Moto France vous remercie.<br /><br />
            <a
              href="https://moto.honda.fr/motorcycles/range/street/hornet/overview.html"
              class="h2 text-rouge text-transform-none"
            >
              Découvrez la Nouvelle CB 750 Hornet
            </a>
          </strong>
        </span>
        <span v-else>
          Vous avez reçu un email de Honda Moto France
          <strong>accusant réception de votre demande d’essai</strong>.<br
            class="d-none d-md-inline"
          />Si vous ne remarquez rien dans votre boîte de messagerie principale,
          veuillez vérifier vos spams et vérifier l’email
          <strong class="text-nowrap"
            >« ne-pas-repondre@notification.honda.fr »</strong
          >. <br /><br />Merci et à très bientôt en concession !
        </span>
      </div>

      <form
        class="needs-validation form-horizontal"
        method="POST"
        id="form"
        @keydown.enter.prevent.stop=""
        v-else
      >
        <div
          v-if="campagne.url.includes('nouvelle-hornet')"
          class="font-size-20"
        >
          <strong>
            Assurez-vous d’être parmi les premiers à la découvrir lors d’un
            évènement spécialement organisé pour vous&nbsp;!
          </strong>
          <br /><br />

          Comment faire&nbsp;? Rien de plus simple. Remplissez dès maintenant le
          formulaire pour participer au lancement de la nouvelle Hornet.
          <br /><strong>SAVE THE DATE : 9 février 2023&nbsp;**</strong> au sein
          de votre concession Honda moto. <br /><br />

          Venez partager un moment convivial et échanger sur la nouvelle Hornet.
          <br />
          Nous vous attendons nombreux ! <br /><br />
          <span class="font-italic font-size-16">
            ** Toutes les modalités de l'évènement vous seront communiquées
            ultérieurement<br />
            Attention, la date peut être différente selon les concessions. Se
            rapprocher de sa concession pour plus de détails.
          </span>
          <br /><br /><br />
        </div>
        <div class="form-group row mb-0">
          <!-- TODO trouver une autre solution que d'utiliser le campagne.id -->
          <label
            v-if="
              campagne.id !== 5 &&
              campagne.id !== 3 &&
              !campagne.url.includes('nouvelle-hornet')
            "
            class="control-label col-12"
          >
            Quel véhicule souhaitez-vous essayer ?*
          </label>

          <label
            v-if="campagne.url.includes('nouvelle-hornet')"
            class="control-label col-12"
          >
            Complétez le formulaire pour participer à l'évènement&nbsp;:
          </label>

          <!-- TODO trouver une autre solution que d'utiliser le campagne.id -->
          <div class="radio-group col-12" v-if="campagne.id === 1">
            <div class="row justify-content-center">
              <div
                class="col-4 mb-4"
                v-for="modele in sortedModeles"
                :key="'modele' + modele.id"
              >
                <div class="custom-control custom-radio">
                  <input
                    type="radio"
                    :id="'modele' + modele.id"
                    name="modeles"
                    class="custom-control-input"
                    required="required"
                    :value="modele.id"
                    v-model="form.model"
                  />
                  <label
                    class="custom-control-label"
                    :for="'modele' + modele.id"
                  >
                    <span class="text-hidden">{{ modele.label_public }}</span>
                    <img
                      :src="
                        checkObsoleteBrowsers
                          ? '/images/desktop/form-modele/' + modele.id + '.png'
                          : '/images/mobile/form-modele/' + modele.id + '.png'
                      "
                      :srcset="
                        '/images/desktop/form-modele/' +
                        modele.id +
                        '.png 1920w, /images/mobile/form-modele/' +
                        modele.id +
                        '.png 768w'
                      "
                      sizes="30%"
                      :alt="modele.label_public"
                      height="440"
                      width="400"
                      class="img-fluid w-100"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Concession -->
          <div
            class="col-lg-12 col-md-6 mb-4"
            v-else-if="campagne.id === 3"
          ></div>

          <!-- TODO trouver une autre solution que d'utiliser le campagne.id -->
          <div
            class="col-lg-12 col-md-6 mb-4"
            v-else-if="campagne.id !== 5 && this.familles.length > 0"
          >
            <div :class="{ 'wrapper-inputs input-group': true }">
              <select
                name="familles"
                class="form-control select-concess"
                id="familles"
                required="required"
                v-model="familleSelected"
              >
                <option value="">Sélectionnez votre {{ type }}*</option>
                <option
                  v-for="famille in familles"
                  :key="famille.id"
                  :value="famille.id"
                >
                  {{ famille.label }}
                </option>
              </select>
            </div>
          </div>

          <!-- TODO trouver une autre solution que d'utiliser le campagne.id -->
          <div class="col-lg-12 col-md-6 mb-4" v-else-if="campagne.id === 3">
            <div :class="{ 'wrapper-inputs input-group': true }">
              <select
                name="familles"
                class="form-control select-concess"
                id="familles"
                required="required"
                v-model="familleSelected"
                hidden
              >
                <option value="">Sélectionnez votre {{ type }}*</option>
                <option
                  v-for="famille in familles"
                  :key="famille.id"
                  :value="famille.id"
                >
                  {{ famille.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-12 col-md-6 mb-4" v-if="campagne.id === 2">
            <div :class="{ 'wrapper-inputs input-group': true }">
              <select
                name="modeles"
                class="form-control select-concess"
                id="modeles"
                required="required"
                v-model="form.model"
                :disabled="familleSelected === ''"
              >
                <option value="">
                  Précisez la version que vous souhaitez essayer*
                </option>
                <option
                  v-for="modele in filteredModeles"
                  :key="modele.id"
                  :value="modele.id"
                >
                  {{ modele.label_public }}
                </option>
              </select>
            </div>
          </div>

          <!-- Select sur modèles quand pas de familles -->
          <div
            class="col-lg-12 col-md-6 mb-4"
            v-else-if="
              campagne.id !== 5 &&
              this.familles.length < 1 &&
              modeles.length > 1
            "
          >
            <div :class="{ 'wrapper-inputs input-group': true }">
              <select
                name="modeles"
                class="form-control select-concess"
                id="modeles"
                required="required"
                v-model="form.model"
              >
                <option value="">Sélectionnez votre {{ type }}*</option>
                <option
                  v-for="modele in modeles"
                  :key="modele.id"
                  :value="modele.id"
                >
                  {{ modele.label_public }}
                </option>
              </select>
            </div>
          </div>

          <div
            class="col-lg-12 col-md-6 mb-4"
            v-if="sizeOfObject(villes) === 1"
          >
            <div :class="{ 'wrapper-inputs input-group': true }">
              <select
                name="concession"
                class="form-control select-concess"
                id="concession"
                required="required"
                v-model="form.concession"
              >
                <option value="">
                  Sélectionnez le concessionnaire Honda Moto proche de chez
                  vous&nbsp;*
                </option>
                <option
                  v-for="concess in concessions"
                  :key="concess.id"
                  :value="concess.code"
                >
                  {{ concess.nom_social }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-lg-12 col-md-6 mb-4" v-if="sizeOfObject(villes) > 1">
            <div :class="{ 'wrapper-inputs input-group': true }">
              <select
                name="concession"
                class="form-control select-concess"
                id="concession"
                required="required"
                v-model="form.concession"
              >
                <option value="">
                  Sélectionnez le concessionnaire Honda Moto proche de chez
                  vous&nbsp;*
                </option>
                <option
                  v-for="concess in orderedConcessByVilles"
                  :key="concess.id"
                  :value="concess.code"
                >
                  {{ concess.ville | capitalize }} ({{ concess.nom_social }})
                </option>
              </select>
            </div>
          </div>

          <div
            class="col-lg-12 col-md-6 mb-4"
            v-if="sizeOfObject(villes) === 0 && sizeOfObject(concessions) > 0"
          >
            <div :class="{ 'wrapper-inputs input-group': true }">
              <select
                name="concession"
                class="form-control select-concess"
                id="concession"
                required="required"
                v-model="form.concession"
              >
                <option value="">
                  Sélectionnez le concessionnaire Honda Moto proche de chez
                  vous&nbsp;*
                </option>
                <option
                  v-for="concess in orderedConcessByDpt"
                  :key="concess.id"
                  :value="concess.code_concession"
                >
                  {{ concess.departement.code }}
                  <span v-if="concess.departement.code != null">-</span>
                  <!-- Enlève le tiret si le concess.departement.code est vide -->
                  {{ concess.ville_principale | capitalize }} ({{
                    concess.nom_social
                  }})
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div
              :class="{
                'wrapper-inputs input-group': true,
                focus: form.perso_nom !== '',
              }"
            >
              <input
                type="text"
                name="perso_nom"
                class="form-control"
                id="perso_nom"
                required="required"
                v-model="form.perso_nom"
              />
              <label for="perso_nom" class="control-label"> Nom* </label>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div
              :class="{
                'wrapper-inputs input-group': true,
                focus: form.perso_prenom !== '',
              }"
            >
              <input
                type="text"
                name="perso_prenom"
                class="form-control"
                id="perso_prenom"
                required="required"
                v-model="form.perso_prenom"
              />
              <label for="perso_prenom" class="control-label"> Prénom* </label>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div
              :class="{
                'wrapper-inputs input-group': true,
                focus: form.perso_email !== '',
              }"
            >
              <input
                type="text"
                name="perso_email"
                class="form-control"
                id="perso_email"
                required="required"
                v-model="form.perso_email"
              />
              <label for="perso_email" class="control-label"> Email* </label>
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div
              :class="{
                'wrapper-inputs input-group': true,
                focus: form.perso_telephone !== '',
              }"
            >
              <input
                type="tel"
                name="perso_telephone"
                class="form-control"
                id="perso_telephone"
                required="required"
                v-model="form.perso_telephone"
              />
              <label for="perso_telephone" class="control-label">
                <span v-if="campagne.url.includes('nouvelle-hornet')"
                  >Téléphone mobile</span
                >
                <span v-else>Téléphone</span>*
              </label>
            </div>
            <em
              class="mentions d-block mt-1"
              v-if="campagne.url.includes('nouvelle-hornet')"
            >
              Votre numéro sera utilisé pour vous envoyer un sms de rappel 48h
              avant l'évènement
            </em>
          </div>

          <div
            class="col-md-12 mb-4"
            v-if="campagne.url.includes('nouvelle-hornet')"
          >
            <label class="control-label souhait-mail">
              Je souhaite recevoir par email
            </label>

            <div class="input-group">
              <div class="checkbox-group">
                <div class="custom-control custom-checkbox">
                  <input
                    v-model="form.contact_optin"
                    type="checkbox"
                    name="optin"
                    id="news2"
                    class="custom-control-input"
                  />
                  <label class="custom-control-label" for="news2">
                    la newsletter Honda Moto France et de son réseau de
                    concessionnaires
                  </label>

                  <div class="custom-control custom-checkbox mb-2">
                    <input
                      v-model="form.contact_newsletter"
                      type="checkbox"
                      name="newsletters"
                      id="news1"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="news1">
                      des offres commerciales de Honda Moto France et de son
                      réseau de concessionnaires
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <p class="mentions mt-0 mb-3 text-sm-center">
          <strong>*Tous les champs sont obligatoires</strong>
        </p>

        <div class="wrapper-btn justify-content-center">
          <button
            type="submit"
            class="btn btn-rouge"
            @click.prevent.stop="submit"
            v-if="campagne.url.includes('nouvelle-hornet')"
          >
            Je m'inscris
          </button>
          <button
            type="submit"
            class="btn btn-rouge"
            @click.prevent.stop="submit"
            v-else
          >
            Valider
          </button>
        </div>

        <p class="mentions mb-3 text-sm-center">
          <strong
            >En validant vous acceptez nos
            <a
              href="https://moto.honda.fr/motorcycles/useful-links/terms-and-conditions.html"
              target="_blank"
              title="Nouvelle fenêtre"
              >Conditions générales d'utilisation</a
            >
            et notre
            <a
              href="https://moto.honda.fr/motorcycles/useful-links/cookie-policy.html"
              target="_blank"
              title="Nouvelle fenêtre"
              >politique de protection des données</a
            >.</strong
          >
        </p>
        <p
          class="mentions mb-3 text-sm-center"
          v-if="campagne.url.indexOf('fun-family') !== -1"
        >
          <strong>Versions disponibles à l’essai en concession :</strong> Honda
          Moto propose une gamme de motos très large avec plusieurs versions.
          Les concessionnaires Honda ont un nombre de modèles de démonstration
          parfois limité. Si la version de la moto n’est pas disponible en
          concession, votre concessionnaire vous orientera vers la version
          disponible à l’essai. Merci de votre compréhension et bon essai !
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import CookieReader from "../components/CookieReader";
const Form = require("../components/form-validation");
const loaderGeneral = document.getElementById("loader-general");

export default {
  name: "form-reservation",
  props: [],
  data() {
    const codeConcess =
      window.location.search.match(/[?&]dealer=(\d{6})(?=&|$)/) ||
      window.location.pathname.match(/(\d{6})/);
    let form = {
      concession: codeConcess && codeConcess.length > 0 ? codeConcess[0] : "",
      model: "",
      perso_civ: "",
      perso_prenom: "",
      perso_nom: "",
      perso_email: "",
      perso_telephone: "",
      contact_newsletter: 0,
      contact_optin: 0,
      demande_url_page: window.location.href,
    };

    return {
      type: "",
      alreadySubmit: false,
      form: form,
      modeles: window.Catalogue || [],
      concessions: window.Concessions || [],
      villes: window.Villes || [],
      concession_name: window.ConcessionName,
      familles: window.Familles || [],
      campagne: window.Campagne || [],
      familleSelected: window.FamilleSelected || "",
    };
  },
  watch: {
    familleSelected: function () {
      this.form.model =
        this.modeles.length === 1
          ? this.modeles[0].id
          : this.filteredModeles.length === 1
          ? this.filteredModeles[0].id
          : "";
    },
  },
  computed: {
    sortedModeles: function () {
      return this.modeles.sort((a, b) => (a.ordre < b.ordre ? 1 : -1));
    },
    orderedConcessByVilles: function () {
      return _.orderBy(this.concessions, "ville");
    },
    orderedConcessByDpt: function () {
      return _.orderBy(this.concessions, [
        "departement.code",
        "ville_principale",
        "nom_social",
      ]);
    },
    filteredModeles: function () {
      return this.modeles.filter((model) =>
        this.familleSelected !== ""
          ? Number(model.familles[0].id) === Number(this.familleSelected)
          : true
      );
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  mounted() {
    document.addEventListener("familyChoice", (e) => {
      this.familleSelected = parseInt(e.detail.family);
    });

    // TODO trouver une autre solution que d'utiliser le campagne.id
    const familyCheck = [2, 4, 6];
    this.type = familyCheck.includes(this.campagne.id) ? "moto" : "scooter";

    if (this.modeles.length === 1) {
      this.form.model = this.modeles[0].id;
    }

    if (this.familles.length > 0) {
      this.familleSelected =
        this.familles.length === 1
          ? this.familles[0]["id"]
          : this.familleSelected !== ""
          ? this.familleSelected[0]["id"]
          : "";
    } else {
      this.familleSelected = "";
    }
    let myRules = {
      concession: {
        required: true,
      },
      modeles: {
        required: true,
      },
      perso_nom: {
        required: true,
        verifName: true,
      },
      perso_prenom: {
        required: true,
        verifName: true,
      },
      perso_email: {
        required: true,
        verifEmail: true,
      },
      perso_telephone: {
        required: true,
        verifTel: true,
      },
      familles: {
        required: true,
      },
    };
    let myMessages = {
      concession: {
        required: "Veuillez sélectionner un concessionnaire",
      },
      modeles: {
        required:
          "Veuillez sélectionner " +
          (this.campagne.url.indexOf("forza-family") !== -1
            ? "le scooter Forza"
            : "la version") +
          " que vous souhaitez essayer",
      },
      perso_nom: {
        required: "Le champ « Nom » est obligatoire",
      },
      perso_prenom: {
        required: "Le champ « Prénom » est obligatoire",
      },
      perso_email: {
        required: "Le champ « Email » est obligatoire",
        verifEmail:
          "Cet email semble être invalide (Format XXX@XXX.XXX attendu)",
      },
      perso_telephone: {
        required: "Le champ « Téléphone » est obligatoire",
        verifTel: "Ce numéro semble être invalide (Format 10 chiffres attendu)",
      },
      familles: {
        required:
          "Veuillez sélectionner " +
          (this.type == "scooter" ? "le " : "la ") +
          this.type +
          " que vous souhaitez essayer",
      },
    };
    Form.initialize(".needs-validation", myRules, myMessages);
  },
  methods: {
    checkObsoleteBrowsers() {
      return (
        navigator.userAgent.indexOf("Trident") > 0 ||
        navigator.userAgent.indexOf("Edge") > 0 ||
        navigator.userAgent.indexOf("MSIE") > 0
      );
    },
    pageScroll(target, margin = 0) {
      let ww = Math.max($(window).width(), window.innerWidth),
        offset = ww > 767 ? 60 : 40,
        offsetWithMargin = offset + margin;
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top - (offsetWithMargin - 1),
          },
          1000,
          "easeInOutExpo"
        );
    },
    sizeOfObject(obj) {
      if (typeof obj == "object") {
        let size = 0,
          key;
        for (key in obj) {
          if (obj.hasOwnProperty(key)) size++;
        }
        return size;
      } else {
        return obj.length;
      }
    },
    submit() {
      let formSubmitted = Form.submission(".needs-validation");
      if (formSubmitted.length > 0) {
        let margin = 0;
        if (
          this.campagne.url.indexOf("forza-family") !== -1 &&
          formSubmitted[0].element.name === "modeles"
        ) {
          margin = 55;
        } else if (
          this.campagne.url.indexOf("fun-family") !== -1 &&
          formSubmitted[0].element.name === "familles"
        ) {
          margin = 45;
        } else {
          margin = 25;
        }
        this.pageScroll(formSubmitted[0].element, margin);
        return false;
      }
      loaderGeneral.style.display = "block";
      if (CookieReader.exists("p_moto")) {
        this.form.id_provenance = CookieReader.get("p_moto");
      }
      axios
        .post(window.location.pathname, this.form)
        .then(() => {
          this.pageScroll("#form-reservation");
          this.alreadySubmit = true;
          loaderGeneral.style.display = "none";
          dataLayer.push({
            event: "Formulaire",
            eventCategory: "Essai",
            eventLabel: this.form.model,
            eventAction: "Succès Formulaire",
            idConcessionFormulaire: this.form.concession,
          });
        })
        .catch((e) => {
          // Shit hits the fan
          loaderGeneral.style.display = "none";
          console.error(e);
        });
    },
    countVilles() {
      this.concessions;
    },
  },
};
</script>
